import * as Toolkit from '../../../toolkit/index';
import * as UIToolkit from '../../../UIToolkit/index';
import * as Utils from '../../../utils/util';
import * as FrontCubeData from '../../../frontCubeData/index';
import Config from '../../../config/index';

interface ErrorMsgRenderData {
    height: number,
    errorMsgList: Array<string>
}

export function renderErrorMsg(cube: CubeNode): void {
    let renderData: ErrorMsgRenderData = makeRenderData(cube);

    renderDom(cube, renderData);
}

function renderDom(cube: CubeNode, renderData: ErrorMsgRenderData): void {
    let $errorTxt: JQuery<HTMLElement> = cube.jView.find('.shelvesbuild-e-shelves-box__error-txt');
    let errorHmlStr: string = '';

    if (!renderData.errorMsgList.length) {
        return;
    }
    renderData.errorMsgList.forEach((errorMsg) => {
        errorHmlStr += `<p>${errorMsg}</p>`;
    });
    $errorTxt
        .attr('title', '错误信息')
        .css({
            bottom: `${renderData.height + 10}px`
        });
    Toolkit.html($errorTxt, errorHmlStr);
    cube.jView.addClass('has-error');
}

function makeRenderData(cube: CubeNode): ErrorMsgRenderData {
    let height: number = UIToolkit.getPXSizeValue(cube.id, 'height');
    let errorMsgList: Array<string> = makeErrorMsg(cube);

    return {
        height: Utils.isValidateNumber(height) ? height : 300,
        errorMsgList: errorMsgList
    };
}

function makeErrorMsg(cube: CubeNode): Array<string> {
    let result: Array<string> = [];
    let checkError: Array<FreeObjMap> = FrontCubeData.getValue(cube.id, 'warningEnumSet');
    let enumDataList: Array<FreeObjMap> = Config.getGlobalConfig('ERROR_ENUM');

    if (!checkError.length) {
        return result;
    }

    let errorMap: FreeObjMap = {};

    enumDataList.forEach(function(enumData: FreeObjMap): void {
        errorMap[enumData.enumId] = enumData;
    });
    checkError.forEach((error: FreeObjMap): void => {
        // 0 未选中，1 选中，2 禁用
        if (errorMap[error.key] && errorMap[error.key].status + '' === '1') {
            result.push(error.value);
        }
    });

    return result;
}
